import { func, string } from 'prop-types'
import { kuiperClassNames } from '../utils'
import * as DiffImpl from './DiffMatchPatchImpl'

import './styles.scss'

const identity = (i) => i

export const Hydration = ({ diffResult, hydrate }) => hydrate(diffResult)

const PlaintextDiff = ({
  diff = DiffImpl.diff,
  hydrate = DiffImpl.hydrate,
  newText = '',
  oldText = '',
  theme = 'standard',
  transform = identity,
}) => {
  const diffResult = diff(transform(oldText), transform(newText))
  return (
    <div className={kuiperClassNames('plaintext-diff', theme)}>
      <Hydration diffResult={diffResult} hydrate={hydrate} />
    </div>
  )
}
PlaintextDiff.propTypes = {
  diff: func,
  hydrate: func,
  newText: string,
  oldText: string,
  theme: string,
  transform: func,
}

export default PlaintextDiff
